import React, { useState } from "react";
import { Box, TextField, Popover, InputAdornment, IconButton } from "@material-ui/core";
import { DateRange } from "react-date-range";
import enUS from "date-fns/locale/en-US";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import dayjs from "dayjs";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

export default function DateRangeSelector({ newRuleAcceptable, setNewRuleAcceptable }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [dateRange, setDateRange] = useState([
    {
      startDate: newRuleAcceptable?.[0] ? new Date(newRuleAcceptable[0]) : new Date(),
      endDate: newRuleAcceptable?.[1] ? new Date(newRuleAcceptable[1]) : new Date(),
      key: "selection",
    },
  ]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    setDateRange([ranges.selection]);
    setNewRuleAcceptable([
      dayjs(startDate).toISOString(),
      dayjs(endDate).toISOString(),
    ]);
  };

  const open = Boolean(anchorEl);

  const formatDisplayDate = () => {
    if (newRuleAcceptable?.[0] && newRuleAcceptable?.[1]) {
      const start = dayjs(newRuleAcceptable[0]).format("DD/MM/YYYY");
      const end = dayjs(newRuleAcceptable[1]).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    }
    return "Select Date Range";
  };

  return (
    <Box>
      <TextField
        variant="outlined"
        size="small"
        value={formatDisplayDate()}
        onClick={handleClick}
        InputProps={{
          readOnly: true,
          style: { 
            height: 40, 
            fontFamily: '"Montserrat", sans-serif', 
            fontSize: 14,
            cursor: "pointer",
            width: 280
          },
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClick}>
                <CalendarTodayIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <DateRange
          editableDateInputs={true}
          onChange={handleSelect}
          moveRangeOnFirstSelection={false}
          ranges={dateRange}
          months={2}
          direction="horizontal"
          rangeColors={["#00445D"]}
          showMonthAndYearPickers={true}
          locale={enUS}
        />
      </Popover>
    </Box>
  );
}
